import { AccordionTestIdFactory, IconButtonTestIdFactory, MenuTestIdFactory, } from '@lucidlink/uicore/interactions';
export const FilespaceListItemTestIdFactory = {
    // Bases - can be used externally for regex matching in getByTestId
    // to select multiple components regardless of their passed test id
    getFilespaceListItemBase: () => 'filespace-list-item',
    getFilespaceListItemNameBase: () => [
        FilespaceListItemTestIdFactory.getFilespaceListItemBase(),
        'name',
    ].join('-'),
    getFilespaceListItemInnerContainerBase: () => [
        FilespaceListItemTestIdFactory.getFilespaceListItemBase(),
        'inner-container',
    ].join('-'),
    getFilespaceListItemStatusIconBase: () => [
        FilespaceListItemTestIdFactory.getFilespaceListItemBase(),
        'status-icon',
    ].join('-'),
    // for test id generation
    getFilespaceListItemTestId: (testId) => [
        FilespaceListItemTestIdFactory.getFilespaceListItemBase(),
        testId,
    ].join('-'),
    getFilespaceListItemNameTestId: (testId) => [
        FilespaceListItemTestIdFactory.getFilespaceListItemNameBase(),
        testId,
    ].join('-'),
    getFilespaceListItemStatusIconTestId: (status, testId) => [
        FilespaceListItemTestIdFactory.getFilespaceListItemStatusIconBase(),
        status,
        testId,
    ].join('-'),
    getFilespaceListItemMenuTriggerButtonTestId: (testId) => IconButtonTestIdFactory.getIconButtonTestId(testId),
    getFilespaceListItemMenuDialogTestId: () => MenuTestIdFactory.getMenuDialogTestId(FilespaceListItemTestIdFactory.getFilespaceListItemBase()),
    getFilespaceListItemHeaderButton: (testId) => AccordionTestIdFactory.getAccordionHeaderButtonTestId(testId),
};
